import { createSlice } from '@reduxjs/toolkit';

import { BloggersFilterState, VerifyType } from './types';

import type { RootState } from 'features/store/store';
import type { PayloadAction } from '@reduxjs/toolkit';

const initialState: BloggersFilterState = {
  search: '',
  category: 'all',
  pricePost: undefined,
  priceCpm: undefined,
  priceCpa: undefined,
  verify: undefined,
};

export const bloggersFilterSlice = createSlice({
  name: 'bloggersFilter',
  initialState,
  reducers: {
    setSearchBloggersFilter: (state, action: PayloadAction<string>) => {
      state.search = action.payload;
    },
    setCategoryBloggersFilter: (state, action: PayloadAction<string>) => {
      state.category = action.payload;
    },
    setPricePostBloggersFilter: (state, action: PayloadAction<string | undefined>) => {
      state.pricePost = action.payload;
    },
    setPriceCpmBloggersFilter: (state, action: PayloadAction<string | undefined>) => {
      state.priceCpm = action.payload;
    },
    setPriceCpaBloggersFilter: (state, action: PayloadAction<string | undefined>) => {
      state.priceCpa = action.payload;
    },
    setVerifyBloggersFilter: (state, action: PayloadAction<VerifyType | undefined>) => {
      state.verify = action.payload;
    },
    resetFiltersBloggersFilter: (state) => {
      return initialState;
    },
  },
});

export const bloggersFilterActions = bloggersFilterSlice.actions;

export const selectBloggersFilter = (state: RootState) => state.bloggersFilter;

export default bloggersFilterSlice.reducer;
